import styled from "styled-components";

import Price from "@evr/components/Price";
import { LicenceType } from "@evr/constant";
import { Currency, PricingRule } from "@evr/types";

interface SingleUserPricingProps {
  pricingRules: PricingRule[];
  transactionCurrency: Currency;
  licenceType: LicenceType;
}

const PricingHeader = styled.h4`
  font-size: 1.75rem;
`;

const SingleUserPricing = ({ pricingRules, transactionCurrency }: SingleUserPricingProps) => {
  const price = pricingRules && pricingRules.length > 0 ? pricingRules[0].transactionCostIncTax : 0;

  return (
    <>
      <PricingHeader>
        <Price transactionCurrency={transactionCurrency} price={price ?? 0} />
      </PricingHeader>
      {<span>Per Month</span>}
    </>
  );
};

export default SingleUserPricing;
